import React, { useContext } from "react";
import styled, { css } from "styled-components";

import { DarkModeContext } from "../context/DarkModeContext";
import { COLORS } from "./constants";

const Subtitle = ({ subtitle }) => {
  const { isDarkModeOn } = useContext(DarkModeContext);
  return <SubtitleStyled>{subtitle}</SubtitleStyled>;
};

export default Subtitle;

// 🎨 Styled Components
const SubtitleStyled = styled.h2`
  font-size: calc(15.6px + (16 - 14) * ((100vw - 300px) / (1600 - 300)));
  font-family: "Montserrat", sans-serif;
  color: ${COLORS.grey};
  font-weight: 500;
  text-align: left;
  line-height: 1.8;
  margin-bottom: 0.6rem;
  ${(props) =>
    props.isDarkModeOn &&
    css`
      color: ${COLORS.mainAqua};
    `}
  &::selection {
    background-color: ${COLORS.somOrange};
    color: ${COLORS.white};
  }
`;
